// import { Controller, Post, Body, Get } from '@nestjs/common';
// import { TranslationService } from './translation.service';
// import { CommonResponse } from '@boi/shared-models';

// class TranslateDto {
//     text: string;
// }

// @Controller('translation')
// export class TranslationController {
//     constructor(private readonly translationService: TranslationService) { }

//     @Post('translate-to-hindi')
//     async translateToHindi(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
//         return this.translationService.translateToHindi(translateDto.text);
//     }

//     @Get('health')
//     async healthCheck(): Promise<CommonResponse> {
//         return this.translationService.healthCheck();
//     }
// }















import { Controller, Post, Body, Get, Param } from '@nestjs/common';
import { TranslationService } from './translation.service';
import { CommonResponse } from '@boi/shared-models';

class TranslateDto {
    text: string;
}

class TranslateToLanguageDto extends TranslateDto {
    targetLanguage: string;
}

@Controller('translation')
export class TranslationController {
    constructor(private readonly translationService: TranslationService) { }

    @Post('translate')
    async translate(@Body() body: TranslateToLanguageDto): Promise<CommonResponse> {
        return this.translationService.translateToLanguage(body.text, body.targetLanguage);
    }

    @Post('translate-to-hindi')
    async translateToHindi(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToHindi(translateDto.text);
    }

    @Post('translate-to-telugu')
    async translateToTelugu(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToTelugu(translateDto.text);
    }

    @Post('translate-to-tamil')
    async translateToTamil(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToTamil(translateDto.text);
    }

    @Post('translate-to-bengali')
    async translateToBengali(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToBengali(translateDto.text);
    }

    @Post('translate-to-marathi')
    async translateToMarathi(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToMarathi(translateDto.text);
    }

    @Post('translate-to-gujarati')
    async translateToGujarati(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToGujarati(translateDto.text);
    }

    @Post('translate-to-kannada')
    async translateToKannada(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToKannada(translateDto.text);
    }

    @Post('translate-to-malayalam')
    async translateToMalayalam(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToMalayalam(translateDto.text);
    }

    @Post('translate-to-punjabi')
    async translateToPunjabi(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToPunjabi(translateDto.text);
    }

    @Post('translate-to-odia')
    async translateToOdia(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToOdia(translateDto.text);
    }

    @Post('translate-to-urdu')
    async translateToUrdu(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
        return this.translationService.translateToUrdu(translateDto.text);
    }

    @Get('languages')
    async getSupportedLanguages(): Promise<CommonResponse> {
        return this.translationService.getSupportedLanguages();
    }

    @Post('translate-batch')
    async translateBatch(@Body() body: { texts: string[]; targetLanguage: string }): Promise<CommonResponse> {
        const results = [];
        for (const text of body.texts) {
            const result = await this.translationService.translateToLanguage(text, body.targetLanguage);
            results.push({
                original: text,
                translated: result.data?.translatedText,
                success: result.status,
                error: result.status ? null : result.internalMessage
            });
        }

        return new CommonResponse(true, 200, 'Batch translation completed', {
            total: body.texts.length,
            successful: results.filter(r => r.success).length,
            failed: results.filter(r => !r.success).length,
            results
        });
    }
}







// translation.controller.ts
// import { Controller, Post, Body, Get, Param } from '@nestjs/common';
// import { TranslationService } from './translation.service';
// import { CommonResponse } from '@boi/shared-models';

// class TranslateDto {
//     text: string;
// }

// class TranslateToLanguageDto extends TranslateDto {
//     targetLanguage: string;
// }

// @Controller('translation')
// export class TranslationController {
//     constructor(private readonly translationService: TranslationService) { }

//     @Post('translate-to-hindi')
//     async translateToHindi(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
//         return this.translationService.translateToHindi(translateDto.text);
//     }

//     @Post('translate-to-telugu')
//     async translateToTelugu(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
//         return this.translationService.translateToTelugu(translateDto.text);
//     }

//     @Post('translate-to-urdu')
//     async translateToUrdu(@Body() translateDto: TranslateDto): Promise<CommonResponse> {
//         return this.translationService.translateToUrdu(translateDto.text);
//     }

//     @Post('translate-to-language')
//     async translateToLanguage(@Body() translateDto: TranslateToLanguageDto): Promise<CommonResponse> {
//         return this.translationService.translateToLanguage(translateDto.text, translateDto.targetLanguage);
//     }

//     @Get('health')
//     async healthCheck(): Promise<CommonResponse> {
//         return this.translationService.healthCheck();
//     }
// }